import { Component } from 'preact';
import PropTypes from 'prop-types';
import Card from '../../../Cards/UsedVehiclesFiatV2';
import CardPlaceholder from '../../../Cards/Placeholder';
import isMobile from '../../../../utils/isMobile';

class ListUsedVehiclesClassic extends Component {
  componentDidUpdate() {
    window.matchHeight.match('.used-vehicles-listing__content');
  }

  formatPrice(priceValue) {
    if (!priceValue) return null;

    const formattedPrice = priceValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
    });

    return formattedPrice;
  }

  formatKm(km) {
    if (!km) return null;

    const formattedKm = km.toLocaleString('pt-BR');

    return formattedKm;
  }

  render() {
    const { moduleLink, vehiclesList, loading, loadingMore, cardIcons } =
      this.props;

    return (
      <div
        className="used-vehicles-listing__content"
        data-vehicles-list-empty={!loading && vehiclesList.length === 0}
      >
        {loading &&
          !loadingMore &&
          Array.from({ length: 12 }).map(item => (
            <CardPlaceholder key={item} long />
          ))}
        {vehiclesList.length > 0 &&
          vehiclesList.map((vehicle, index) => (
            <Card
              title={vehicle.model}
              subtitle={vehicle.subtitle}
              badge={vehicle.badge}
              unit={vehicle.item_unit.name}
              image={vehicle.image || vehicle.item_image.middle_image}
              link={`${moduleLink}/${vehicle.slug}`}
              price={this.formatPrice(vehicle.price)}
              old_price={this.formatPrice(vehicle.old_price)}
              km={this.formatKm(vehicle.km)}
              exchange={vehicle.exchange}
              fuelText={vehicle.fuel_text}
              mainImageLazy={isMobile() ? index > 0 : index > 3}
              icons={cardIcons}
            />
          ))}
        {!loading && vehiclesList.length === 0 && (
          <p className="used-vehicles-listing__no-vehicles-message">
            Nenhum veículo seminovo encontrado.
          </p>
        )}
      </div>
    );
  }
}

ListUsedVehiclesClassic.defaultProps = {
  vehiclesList: [],
  loading: true,
  loadingMore: false,
  moduleLink: null,
  cardIcons: [],
};

ListUsedVehiclesClassic.propTypes = {
  vehiclesList: PropTypes.arrayOf(),
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  moduleLink: PropTypes.string,
  cardIcons: PropTypes.shape({}),
};

export default ListUsedVehiclesClassic;
